// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-button{height:inherit}`, "",{"version":3,"sources":["webpack://./src/components/Common/UI/Button/Style.scss"],"names":[],"mappings":"AAEA,WACE,cAAA","sourcesContent":["@use \"~@emisgroup/design-tokens/build/scss/variables\" as tokens;\n\n.ui-button {\n  height: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
